import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BIGC_BIGLINE_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY || "RE1LVC1CaWdDLUludGVybmFs";

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "x-api-key": API_KEY,
  },
});

// Request interceptor - add headers from context/localStorage
api.interceptors.request.use(
  (config) => {
    // Get LINE MID
    const lineMid = localStorage.getItem("userId");
    if (lineMid) {
      config.headers["x-line-mid"] = lineMid;
    }

    // Get auth token
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    // Add client auth
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;
    if (clientAuth) {
      config.headers["X-Client-Auth"] = clientAuth;
    }

    // Add language
    const language = localStorage.getItem("i18nextLng") || "TH";
    config.headers["Accept-Language"] = language.toUpperCase();

    // Add x-api-key
    config.headers["x-api-key"] = process.env.REACT_APP_BIGC_BIGLINE_API_KEY;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ✅ FIXED: Response interceptor - preserve error structure
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      // ✅ Preserve full error response structure
      const errorData = error.response.data;
      
      // Create custom error with full details
      const customError = new Error(
        errorData?.message || 
        errorData?.error || 
        'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
      );
      
      // ✅ Attach full response data
      customError.response = error.response;
      customError.status = error.response.status;
      customError.data = errorData;
      
      // Handle specific errors
      if (error.response.status === 401) {
        // Unauthorized - redirect to login
        //window.location.href = '/login';
      }

      throw customError;
    } else if (error.request) {
      const networkError = new Error("ไม่สามารถเชื่อมต่อได้ กรุณาตรวจสอบอินเทอร์เน็ต");
      networkError.isNetworkError = true;
      throw networkError;
    } else {
      throw new Error(error.message);
    }
  },
);

// =====================================================
// FORTUNE CARD APIs
// =====================================================

export const fortuneCardApi = {
  // Link BigPoint account
  bigpointLink: async () => {
    return await api.post("/game-bigpoint/link");
  },

  // Open fortune card
  openCard: async () => {
    const lineMid = localStorage.getItem("userId");

    if (!lineMid) {
      throw new Error("LINE MID not found");
    }

    console.log("[API] Opening card for LINE MID:", lineMid);

    // ✅ เรียก initPlayer ก่อนเสมอ
    try {
      await fortuneCardApi.initPlayer();
      console.log("[API] ✅ Player initialized");
    } catch (error) {
      console.error("[API] ❌ Player init failed:", error);
      // ถ้า init ไม่สำเร็จก็ยังพยายาม open card ต่อ
    }

    return await api.post("/game-card-fortune/card/open", {
      lineMid: lineMid,
    });
  },

  // Get card status
  getCardStatus: async () => {
    return await api.get("/game-card-fortune/card/status");
  },

  // ✅ NEW: Create group
  createGroup: async () => {
    return await api.post("/game-card-fortune/group/create");
  },

  // ✅ NEW: Get user's owned group
  getMyOwnedGroup: async () => {
    return await api.get("/game-card-fortune/group/my-owned");
  },

  // ✅ Get groups where user joined as member
  getMyJoinedGroups: async () => {
    return await api.get("/game-card-fortune/group/my-joined");
  },

  // Get group status
  getGroupStatus: async (groupCode) => {
    return await api.get(`/game-card-fortune/group/${groupCode}/status`);
  },

  // Get player rewards
  getRewards: async () => {
    return await api.get("/game-card-fortune/rewards");
  },

  // ✅ Initialize player (create if not exists)
  initPlayer: async () => {
    const lineMid = localStorage.getItem("userId");
    const displayName = localStorage.getItem("line_display_name");
    const pictureUrl = localStorage.getItem("line_picture_url");
    const bigCardNumber = localStorage.getItem("bigCardNumber");

    return await api.post("/game-bigpoint/init", {
      lineId: lineMid,
      displayName: displayName || "ผู้เล่น",
      pictureUrl: pictureUrl || null,
      bigpointId: bigCardNumber || null,
    });
  },

  // ✅ FIXED: Join group - handle errors properly
  joinGroup: async (groupCode) => {
    try {
      const response = await api.post("/game-card-fortune/group/join", {
        group_code: groupCode,
      });
      
      console.log("[API] Join group response:", response);
      
      // ✅ Return full response (already unwrapped by interceptor)
      return response;
      
    } catch (error) {
      console.log("[API] Join group error:", error);
      
      // ✅ Error already has full structure from interceptor
      // Just re-throw it
      throw error;
    }
  },

  // ✅ Get group members
  getGroupMembers: async (groupCode) => {
    return await api.get(`/game-card-fortune/group/${groupCode}/members`);
  },

  getRewardAStatus: async () => {
    return await api.get("/game-card-fortune/reward-a/status");
  },

  // Get my rewards
  getMyRewards: async () => {
    return await api.get("/game-card-fortune/my-rewards");
  },
};

export default fortuneCardApi;